import {Component, OnInit, OnDestroy} from '@angular/core';
import {User} from '../../../../../models/user';
import {BusinessDataService} from '../../../../../data-repositories/business-data.service';
import {StagesNavigationService} from '../../../stages-navigation/stages-navigation.service';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';

@Component({
  standalone: false,
  selector: 'app-address-second-holder',
  templateUrl: './address-second-holder.component.html',
  styleUrls: ['./address-second-holder.component.scss']
})
export class AddressSecondHolderComponent implements OnInit, OnDestroy {
  user: User;
  private subscription = new Subscription();

  constructor(
    private service: BusinessDataService,
    public navigationService: StagesNavigationService) {

    this.subscription.add(this.service.GetUser().subscribe(s => {
      this.user = s.model;
    }));
  }

  ngOnInit() {
  }

  public updateUser(): void {
    this.service.updateUserWithoutValidation(this.user, () => {
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

}
